import { TypographyOptions } from '@mui/material/styles/createTypography'

export const typography: TypographyOptions = {
  fontFamily: "'Suisse Intl', Helvetica, sans-serif",
}
